import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as CartIconSVG } from '../../assets/images/cart.svg';
import LogoutIcon from '@mui/icons-material/Logout';
import LoginIcon from '@mui/icons-material/Login';

export default function CartIcon() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("cartItems");
    navigate("/");
  };

  const handleLogin = () => {
    navigate("/login"); // Adjust this route to your login page
  };

  return (
    <div className="flex items-center space-x-4">
      <div className="flex items-center space-x-2 cursor-pointer">
        <CartIconSVG className="w-6 h-6 text-gray-800" />
        <span className="text-gray-800 font-semibold">View Cart</span>
      </div>
      
      {token ? (
        <div 
          className="flex items-center space-x-2 cursor-pointer"
          onClick={handleLogout}
        >
          <LogoutIcon className="w-6 h-6 text-gray-800" />
          <span className="text-gray-800 font-semibold">Logout</span>
        </div>
      ) : (
        <div 
          className="flex items-center space-x-2 cursor-pointer"
          onClick={handleLogin}
        >
          <LoginIcon className="w-6 h-6 text-gray-800" />
          <span className="text-gray-800 font-semibold">Login</span>
        </div>
      )}
    </div>
  );
}